import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {PRISM_OVERRIDES} from './prismjs-overrides';

export const CodeSnippetContainer = styled.div<{
  $isExpanded: boolean;
  $backgroundColor?: string;
}>`
  position: relative; // needed to help position copy icon
  max-height: ${props => (props.$isExpanded ? '100%' : 'calc(500px + 54px)')};
  background-color: ${props => props.$backgroundColor ?? globals.MOON_100};
  border: 1px solid ${globals.MOON_250};
  border-radius: 4px;
  width: 100%;
  padding: 8px;
`;
CodeSnippetContainer.displayName = 'S.CodeSnippetContainer';

export const CodeCopyButton = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;

  padding: 6px 12px;
  height: 24px;
  background-color: ${globals.GRAY_TRANSPARENT};
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  font-size: 14px;
  line-height: 18px;

  svg {
    width: 18px;
    height: 18px;
  }

  :hover {
    cursor: pointer;
    background-color: ${hexToRGB(globals.TEAL_300, 0.48)};
    color: ${globals.TEAL_550};
  }
`;
CodeCopyButton.displayName = 'S.CodeCopyButton';

export const CodeSnippet = styled.div<{
  $isExpanded: boolean;
}>`
  max-height: ${props => (props.$isExpanded ? '100%' : '500px')};
  overflow: hidden;
  display: flex;
`;
CodeSnippet.displayName = 'S.CodeSnippet';

export const PrismCodeHighlighting = styled.code`
  font-family: 'Source Code Pro' !important;
  font-size: 14px !important;
  text-align: left;
  white-space: pre-wrap !important;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  hyphens: none;

  ${PRISM_OVERRIDES}
`;
PrismCodeHighlighting.displayName = 'S.PrismCodeHighlighting';

export const CodeSnippetExpandCollapse = styled.div`
  width: 100%;
  height: 24px;
  background-color: ${globals.MOON_100};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin-top: 10px;

  color: ${globals.MOON_800};
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;

  svg {
    width: 18px;
    height: 18px;
  }

  :hover {
    cursor: pointer;
    background-color: ${hexToRGB(globals.TEAL_300, 0.48)};
    color: ${globals.TEAL_550};
  }
`;
CodeSnippetExpandCollapse.displayName = 'S.CodeSnippetExpandCollapse';

export const IconContainer = styled.div`
  display: flex;
  gap: 4px;
`;
IconContainer.displayName = 'S.IconContainer';
